// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"skeleton_wrapper__14hAv","shine":"skeleton_shine__1prFu"};